import { c as _c } from "react/compiler-runtime";
import * as React from "react";
const ExpoIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg viewBox="0 0 128 128"><path d="M60.654 48.883c1.051-1.534 2.197-1.727 3.127-1.727s2.475.193 3.527 1.727C75.556 60.12 89.173 82.512 99.22 99.035c6.555 10.767 11.586 19.043 12.622 20.095 3.874 3.952 9.189 1.489 12.278-2.995 3.039-4.412 3.88-7.512 3.88-10.817 0-2.253-44.052-83.515-48.486-90.28C75.25 8.534 73.856 6.89 66.56 6.89h-5.469c-7.28 0-8.331 1.644-12.599 8.148C44.058 21.803 0 103.065 0 105.313c0 3.31.847 6.41 3.892 10.822 3.088 4.484 8.403 6.947 12.278 2.99 1.03-1.053 6.061-9.323 12.615-20.095 10.047-16.518 23.62-38.91 31.874-50.153z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ExpoIcon;